import TaskPanel from '../TaskPanel'
import {connect} from '../../../redux/utils'
import {
    canModifyAnyManager,
    canModifyAnyUser,
    getAssignedManagers,
    getAssignedUsers,
    getBillingType,
    getCustomerName,
    getEstimatedTime,
    getLastTaskPanelTabKey,
    getProjectName,
    getTaskDeadline,
    getTaskDescription,
    getTaskName,
    getTaskPanelErrors,
    getTaskPanelTabKey,
    getTaskStatusId,
    isTaskCompleted,
    isNeedInitializeFocus,
    getCustomFieldsValuesWithDefaults,
} from './selectors'
import {bindActionCreators} from 'redux'
import {isBRAEnabled, isBTYEnabled, isESTEnabled, isTTAEnabled, isTWSEnabled, isTZGEnabled, isUGREnabled, isURAEnabled, isWASEnabled} from '../../../features/selectors'
import {
    cancelTaskCreation,
    createTask,
    deleteAssignedManager,
    deleteAssignedUser,
    openLastTaskPanelTab,
    setLastTaskPanelTab,
    setTaskPanelTab,
    updateAssignedManagers,
    updateAssignedUsers,
    updateCustomField,
    updateDeadline,
    updateDescription,
    updateEstimate,
    updateName,
    updateStatus,
    updateTypeOfWork,
} from './actions'
import {getTimeZoneGroups, getUserGroups} from '../../../entities/selectors'
import {getSortedTypeOfWorkList} from '../../../typesOfWork/selectors'
import {selectTaskCustomFields} from '../../../customFields/selectors'
import { canGenerateMoneyReports } from '../../../loggedInUser/selectors'

export default connect(
    state => ({
        name: getTaskName(state),
        workflowStatusId: getTaskStatusId(state),
        completed: isTaskCompleted(state),
        deadline: getTaskDeadline(state),
        typeOfWork: getBillingType(state),
        typesOfWork: getSortedTypeOfWorkList(state),
        estimatedTime: getEstimatedTime(state),
        description: getTaskDescription(state),
        canReopenProject: true,

        isBTYEnabled: isBTYEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isBRAEnabled: isBRAEnabled(state),
        isTWSEnabled: isTWSEnabled(state),
        isESTEnabled: isESTEnabled(state),
        isWASEnabled: isWASEnabled(state),
        isTTAEnabled: isTTAEnabled(state),

        errors: getTaskPanelErrors(state),
        projectName: getProjectName(state),
        customerName: getCustomerName(state),
        assignedUsers: getAssignedUsers(state),
        assignedManagers: getAssignedManagers(state),
        userGroupsEnabled: isUGREnabled(state),
        timeZoneGroupsEnabled: isTZGEnabled(state),
        userGroups: getUserGroups(state),
        timeZoneGroups: getTimeZoneGroups(state),
        canModifyAnyUser: canModifyAnyUser(state),
        canModifyAnyManager: canModifyAnyManager(state),
        canGenerateMoneyReports: canGenerateMoneyReports(state),

        currentTabKey: getTaskPanelTabKey(state),
        lastSelectedTabKey: getLastTaskPanelTabKey(state),
        isNeedInitializeFocus: isNeedInitializeFocus(state),

        customFields: selectTaskCustomFields(state),
        customFieldsValues: getCustomFieldsValuesWithDefaults(state),
    }),
    dispatch => ({
        closeTaskPanel: bindActionCreators(cancelTaskCreation, dispatch),
        createTask: bindActionCreators(createTask, dispatch),
        deleteAssignedUser: bindActionCreators(deleteAssignedUser, dispatch),
        updateAssignedUsers: bindActionCreators(updateAssignedUsers, dispatch),
        deleteAssignedManager: bindActionCreators(deleteAssignedManager, dispatch),
        updateAssignedManagers: bindActionCreators(updateAssignedManagers, dispatch),
        setTaskPanelTab: bindActionCreators(setTaskPanelTab, dispatch),
        setLastTaskPanelTab: bindActionCreators(setLastTaskPanelTab, dispatch),
        openLastTaskPanelTab: bindActionCreators(openLastTaskPanelTab, dispatch),
        ...bindActionCreators({
            updateName,
            updateStatus,
            updateDeadline,
            updateTypeOfWork,
            updateEstimate,
            updateDescription,
            updateCustomField,
        }, dispatch),
    })
)(TaskPanel)


// WEBPACK FOOTER //
// ./web/js/panels/task/createPanel/CreateTaskPanel.js